import React, { useCallback } from "react";

/**
 * Single field for the refactored contact form (no legacy gform markup).
 */
export default function ContactFormField({
  id,
  label,
  type = "text",
  reg,
  error,
  required = false,
  maxLength,
  charCount,
  t,
  textareaRows = 6,
}) {
  const errId = `${id}-err`;
  const { ref: regRef, ...regRest } = reg || { ref: undefined };

  const setRef = useCallback(
    (node) => {
      if (regRef == null) return;
      if (typeof regRef === "function") regRef(node);
      else regRef.current = node;
    },
    [regRef]
  );

  const describedBy = error ? errId : undefined;
  const invalid = Boolean(error);

  return (
    <div className={`vh-cf-field${invalid ? " vh-cf-field--invalid" : ""}`}>
      <label className="vh-cf-label" htmlFor={id}>
        <span className="vh-cf-label__text">{label}</span>
        {required ? (
          <span className="vh-cf-label__req" aria-hidden="true">
            *
          </span>
        ) : null}
      </label>

      {type === "textarea" ? (
        <textarea
          {...regRest}
          ref={setRef}
          id={id}
          className="vh-cf-textarea"
          rows={textareaRows}
          maxLength={maxLength}
          aria-invalid={invalid}
          aria-describedby={describedBy}
          aria-required={required}
        />
      ) : (
        <input
          {...regRest}
          ref={setRef}
          id={id}
          type={type}
          className="vh-cf-input"
          maxLength={maxLength}
          aria-invalid={invalid}
          aria-describedby={describedBy}
          aria-required={required}
        />
      )}

      {maxLength != null && typeof charCount === "number" && t ? (
        <p className="vh-cf-char" aria-live="polite">
          {t("contact.charCounter", { current: charCount, max: maxLength })}
        </p>
      ) : null}

      {error ? (
        <p id={errId} className="vh-cf-field-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
